import { TermsOfUseInput, TermsOfUseOutput } from "@/interfaces/terms-of-use";
import { BaseService } from "./BaseService";

export class TermsOfUseService extends BaseService<
  TermsOfUseInput,
  TermsOfUseOutput
> {
  constructor() {
    super();
    this.path = "terms_of_use";
  }

  async accept(id: string) {
    return this.request(`${this.path}/${id}/accept`, {
      method: "POST",
    }) as Promise<TermsOfUseOutput>;
  }
}
